import React from 'react';
import CricketComp from './Cricket.component';

class Cricket extends React.Component {
    componentDidMount() {
        CricketComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Cricket;